import React from 'react';
import { Bar } from 'react-chartjs-2';
import './chartSetup';
import { useThemeMode } from '../theme';
import { buildBar } from './builders';
import { themePalette } from './palette';

// Bar chart. Plain mode: `data` from charts.prepareCategories
// [{ label, value }]. Stacked mode: `data` from
// charts.prepareStacked { labels, series: [{ label, series }] } rendered as
// vertically stacked bars, one dataset per series (size groups).
export default function BarViz({ data, stacked }) {
  useThemeMode();
  const { data: chartData, options } = buildBar(data, stacked, themePalette());
  return <Bar data={chartData} options={options} />;
}
